import { Pipe, PipeTransform } from '@angular/core';
import { PromotedVolume } from '../Model/PromotedVolume.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'PromotedVolumeFilter',
  standalone: false
})
export class PromotedVolumeFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(promotedVolumes: PromotedVolume[], searchTerm: string, field: string): PromotedVolume[] {
    if (!promotedVolumes || !searchTerm) return promotedVolumes;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return promotedVolumes.filter(promoVolume =>
      this.matchesSearchTerm(promoVolume, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(promoVolume: PromotedVolume, term: string): boolean {
    return (
      this.stringMatches(promoVolume.marketCompanyName, term) ||
      this.stringMatches(promoVolume.shopperTypeLabel, term) ||
      this.dateMatches(promoVolume.applicationDate, term) ||
      this.stringMatches(promoVolume.shareOfPromotedVolumeRatio?.toString(), term) ||
      this.stringMatches(promoVolume.UserName, term) ||
      this.stringMatches(promoVolume.multiplesCategoryLabel, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }

  private dateMatches(date: string | number | Date | null | undefined, term: string): boolean {
    if (!date) return false;
    const formattedDate = this.datePipe.transform(date as string | number | Date, 'MMMM dd, yyyy');
    return formattedDate?.toLowerCase().includes(term) ?? false;
  }
}
